export const bundle = {
  pkg: "@apollo/client-integration-nextjs",
  client: "ApolloClient",
  cache: "InMemoryCache",
};
